/*   MUTATIONS   */
//root

//Bookings
export const UPDATE_BOOKING_LIST = 'UPDATE_BOOKING_LIST'
export const TOGGLE_LOADING_ON = 'TOGGLE_LOADING_ON'
export const TOGGLE_LOADING_OFF = 'TOGGLE_LOADING_OFF'

/*   ACTIONS   */
//root

//Bookings
export const B_UPDATE_BOOKING_LIST = 'B_UPDATE_BOOKING_LIST'
